import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
export var ShopnikeApp = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});